module.exports = __webpack_public_path__ + "static/logo_Vabysmo-f973ffcbfabcb80f917fa0ef7e640029.jpg";